import { createCreateActionType } from "@multiweb/reactUtils";

/**
 * Jméno modulu reportingScalar. Slouží pro jednoznačnou identifikaci modulu.
 */
export const NAME = "reportingScalar";

/**
 * Pomocná funkce pro vytvoření typu akce
 * @param actionType Typ akce
 */
const createActionType = createCreateActionType(NAME);

export const SET_RESULT = createActionType("SET_RESULT");
export const INIT = createActionType("INIT");
export const CLEAR = createActionType("CLEAR");
